<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/">
        <i class="fa fa-home"></i>
        Home
      </b-breadcrumb-item>
      <b-breadcrumb-item to="/FinancialServices/LeaseIDTs">Financial Services</b-breadcrumb-item>
      <b-breadcrumb-item to="/FinancialServices/LeaseIDTs">Lease IDTs</b-breadcrumb-item>
      <b-breadcrumb-item active>
        {{ famisDepartment }} / {{ sl }} - {{ sa }}
      </b-breadcrumb-item>
    </b-breadcrumb>

    <AppLoadingContainer :predicate="isLoading">
      <form @submit.prevent="onSubmit()">
        <div class="card">
          <div class="bg-dark card-header text-white">Edit Lease IDT</div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-sm-12 form-group">
                <label for="sl">SL</label>
                <input class="form-control" v-model="sl" disabled />
              </div>
              <div class="col-md-4 col-sm-12 form-group">
                <label for="sa">SA</label>
                <input class="form-control" v-model="sa" disabled />
              </div>
              <div class="col-md-4 col-sm-12 form-group">
                <label for="famisDepartment">FAMIS Department</label>
                <input class="form-control" v-model="famisDepartment" disabled />
              </div>
              <div class="col-md-4 col-sm-12 form-group">
                <label for="amountCharged">Amount Charged</label>
                <input class="form-control" v-model.number="amountCharged" placeholder="Amount Charged" />
                <transition name="fade">
                  <AppNotification type="danger" v-if="$v.amountCharged.$invalid && submissionAttempted">
                    Amount Charged must be left blank or given a number
                  </AppNotification>
                </transition>
              </div>
            </div>
          </div>
          <div class="card-footer d-print-none text-right">
            <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Submit</button>
            <RouterLink :to="{ name: 'LeaseIDTs' }" class="btn btn-danger">Back</RouterLink>
          </div>
        </div>
      </form>
    </AppLoadingContainer>
  </div>
</template>

<script>
import AppNotification from "@/components/shared/AppNotification";
import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
import LeaseIDTService from "@/services/LeaseIDTsService";
import { ToastType } from "@/services/models/shared/ToastType";

export default {
  components: {
    AppLoadingContainer,
    AppNotification
  },
  data() {
    return { 
      amountCharged: null,
      isSubmitting: false,
      submissionAttempted: false,
      isLoading: true,
    };
  },
  props: {
    sl: {
      type: String,
      required: true
    },
    sa: {
      type: String,
      required: true
    },
    famisDepartment: {
      type: String,
      required: true
    }
  },
  methods: {
    onSubmit() {
      const vm = this;

      // Mark the form as attempted to submit
      this.submissionAttempted = true;

      // Validate the form
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      vm.isSubmitting = true;
      LeaseIDTService.updateLeaseIDT({
        sl: vm.sl,
        sa: vm.sa,
        famisDepartment: vm.famisDepartment,
        amountCharged: vm.amountCharged,
      })
        .then(() => {
          vm.alert(ToastType.Success, 'The amount charged was successfully updated');
          vm.$router.replace({ name: 'LeaseIDTs' });
        })
        .catch(() => {
          vm.alert(ToastType.Danger, 'Account could not be updated');
        })
        .finally(() => {
          vm.isSubmitting = false;
        });
    }
  },
  created() {
    this.amountCharged = this.$route.params.amountCharged;
    this.isLoading = false;
  },
  validations: {
    amountCharged: { 
      validAmount(value) { 
        return (value !== 0 && value > 0);
      }
    }
  }
};
</script>

